// top level toggle: title + "v" caret as separate expand/collapse control
import { keyPressHelper } from '@brandfolder/utilities';
import React from 'react';
import PropTypes from 'prop-types';

import './styles/search_dropdown.scss';

/* Props:
  title: Text to display (not the control; caret "v" is the control)
  ariaExpanded: Expand/collapse state for the caret control
  ariaControls: ID of the dropdown panel for aria-controls
*/
const DropdownToggleButton = ({
  ariaLabel,
  ariaControls,
  ariaExpanded,
  onToggle,
  title = '',
}) => {
  const caretClassName = ariaExpanded ? 'bff-caret-up' : 'bff-caret-down';
  const caretAriaLabel = ariaLabel || (typeof ariaExpanded === 'boolean'
    ? (ariaExpanded ? 'Collapse menu' : 'Expand menu')
    : 'Toggle menu');

  return (
    <div className="search-dropdown__toggle" data-testid="search-dropdown-toggle">
      <span className="search-dropdown__title">{title}</span>
      <button
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-label={caretAriaLabel}
        className="search-dropdown__toggle-caret"
        onClick={onToggle}
        onKeyDown={keyPressHelper(onToggle)}
        tabIndex={0}
        type="button"
      >
        <span className={caretClassName} aria-hidden="true" />
      </button>
    </div>
  );
};

DropdownToggleButton.propTypes = {
  title: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
  ariaLabel: PropTypes.string,
  ariaControls: PropTypes.string,
  ariaExpanded: PropTypes.bool,
};

DropdownToggleButton.defaultProps = {
  ariaExpanded: false,
  ariaLabel: undefined,
  ariaControls: undefined,
  ariaExpanded: undefined,
  onToggle: () => { /* no op */ },
};

export default DropdownToggleButton;
